import React, { useMemo, useCallback } from 'react';
import isNil from 'lodash/isNil';
import includes from 'lodash/includes';
import compact from 'lodash/compact';
import map from 'lodash/map';
import find from 'lodash/find';
import isArray from 'lodash/isArray';

import { ID } from '../../../../../types';

import {
  MultiSelectChangeCallbackType,
  MultiSelectExtendedDataType
} from '../../../../../helpers/MultiSelect/types';

import { useTranslate } from '../../../../../common/hooks/useTranslate';

import { MultiSelect } from '../../../../../helpers/MultiSelect';

import { invoiceProcessingJobSI18nTextStatuses } from '../../../invoiceProcessingJobsConstants';

interface InvoiceProcessingJobsStatusesMultiSelectProps {
  value: ID[];
  availableStatuses?: ID[];
  autoFocus?: boolean;
  onChange: (value: ID[]) => void;
}

function InvoiceProcessingJobsStatusesMultiSelect({
  value,
  availableStatuses,
  autoFocus,
  onChange
}: InvoiceProcessingJobsStatusesMultiSelectProps) {
  const { t } = useTranslate();
  const data = useMemo<MultiSelectExtendedDataType[]>(() => {
    return compact(
      map(invoiceProcessingJobSI18nTextStatuses, (i18nLabel, value) =>
        isNil(availableStatuses) || includes(availableStatuses, value)
          ? {
              value: value,
              label: t(i18nLabel)
            }
          : null
      )
    );
  }, [t, availableStatuses]);

  const multiSelectValue = useMemo<MultiSelectExtendedDataType[]>(() => {
    return isArray(value)
      ? value.map((item) => find(data, ['value', item]))
      : [];
  }, [value, data]);

  const handleChange = useCallback<MultiSelectChangeCallbackType>(
    (value: MultiSelectExtendedDataType) => {
      onChange(isArray(value) ? value.map((item) => item.value) : []);
    },
    [onChange]
  );

  return (
    <MultiSelect
      inputWrapperClassName="block"
      onChange={handleChange}
      value={multiSelectValue}
      multi={true}
      isSearchable={true}
      data={data}
      classNamePrefix="av_multi_select"
      autoFocus={autoFocus}
    />
  );
}

export default InvoiceProcessingJobsStatusesMultiSelect;
